<template>
  <v-col>
    <validation-provider v-slot="{ errors }" :rules="rules" :name="name">
      <v-text-field
        :value="value"
        v-mask="mask"
        :label="label"
        :prepend-icon="icon"
        :error-messages="errors"
        @input="$emit('input', $event)"
      />
    </validation-provider>
  </v-col>
</template>

<script>
export default {
  name: 'ListFiltroModalItemInput',
  props: {
    name: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
    },
    mask: {
      type: String,
    },
    rules: {
      type: [Object, String],
    },
    value: {
      required: true,
    },
  },
  data() {
    return {
      internalValue: '',
    }
  },
}
</script>
